import React, { memo } from 'react';
import { TeamAssistantLiteMarkdownBody } from '../../utils/teamAssistantLiteMarkdown';

/**
 * Markdown for assistant replies — lightweight parser so formatting updates on every stream token.
 * Links render as plain text (no navigation).
 */
const TeamAssistantMarkdownContent = memo(({ content, className = '' }) => {
  const source = content == null ? '' : String(content);

  if (!source.trim()) {
    return null;
  }

  return (
    <div className={`team-assistant-markdown ${className}`.trim()}>
      <TeamAssistantLiteMarkdownBody content={source} />
    </div>
  );
});

TeamAssistantMarkdownContent.displayName = 'TeamAssistantMarkdownContent';

export default TeamAssistantMarkdownContent;
